module.exports = __webpack_public_path__ + "static/media/instagram.eebd4d8b.svg";